import { useEffect, useState } from "react";
import { Autocomplete, TextField } from '@mui/material';
import InputColor from 'react-input-color';
import { useTranslation } from "react-i18next";
import { SelectProperty } from "../../Services/Properties";
import GeneratedPdf from "./Pdf/generated-pdf";

const FilterReport: React.FunctionComponent<{ property: any, OnChangeProperty: any, OnChangeColor: any, onchangeMessageHandler: any, isChange: boolean }> = (props) => {

    const { t } = useTranslation();
    const [properties, setProperties] = useState<any>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        SelectProperty().then((data) => {
            setLoading(false);
            setProperties(data.r)
        }).catch(() => {
            console.log("error")
        })
    }, [])

    const handleSelectChangeProperty = (event: any, newValue: any) => {
        if (newValue) {
            props.OnChangeProperty(newValue.id)
        }
    }

    return (
        <div className="row  marg-1 mt-4 ">
            <div className="col-md-4 mb-3">
                <Autocomplete
                    options={Array.isArray(properties) ? properties : []}
                    getOptionLabel={(property: any) => {
                        const bedroomsLabel = property.bedrooms > 1 ? `${property.bedrooms} bedrooms` : `${property.bedrooms} bedroom`;
                        return `${property.ref} | ${property.location} | ${bedroomsLabel}`;
                    }}
                    disablePortal
                    className="search-bar"
                    renderInput={(params) => <TextField {...params}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                "&::placeholder": {
                                    color: "#000000",
                                    opacity: 1,
                                }
                            }
                        }}
                        placeholder={loading ? t("startUploading.loading") : t("report.searchByPropertyId")}
                    />}
                    onChange={handleSelectChangeProperty}
                />
                {/* <div className="search-bar">
                    <span className="search-icon">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.625 15.75C12.56 15.75 15.75 12.56 15.75 8.625C15.75 4.68997 12.56 1.5 8.625 1.5C4.68997 1.5 1.5 4.68997 1.5 8.625C1.5 12.56 4.68997 15.75 8.625 15.75Z" stroke="#475569" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16.5 16.5L15 15" stroke="#475569" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="search-inputt back-FFFFFF para-14 color-475569 disabled"
                        placeholder={t("report.searchByPropertyId")}
                    />
                </div> */}
            </div>
        </div>
    )
}
export default FilterReport;